export default __webpack_public_path__ + "static/media/mz.064c7b01.svg";